<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" fixed>
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Whats App SMS to students</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense class="justify-center">
        <v-col cols="12" sm="6" md="6">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="template"
            return-object
            :items="sms_template_array"
            item-text="template_name"
            label="Select SMS Template"
            outlined
            @change="get_template(template)"
            persistent-hint
          />
        </v-col>
      </v-row>
      <v-row dense class="justify-center" v-if="preapproved_sms !== ''">
        <v-col cols="12" sm="12" md="6">
          <v-textarea
            outlined
            color="#0F2027"
            v-model="preapproved_sms"
            label="SMS Template Data"
            readonly
          ></v-textarea>
          <!-- </v-card> -->
        </v-col>
      </v-row>
      <v-row class="justify-center" dense v-for="(s, i) in jsonparams" :key="i">
        <!-- <v-col cols="12" sm="2" md="2"></v-col> -->
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            outlined
            dense
            type="text"
            v-model="s.name"
            readonly
            filled
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            color="#0F2027"
            clearable
            dense
            v-model="s.value"
            label="Value"
            placeholder="Enter value"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- file attachment code -->

      <v-row dense justify="center">
        <v-col cols="12" sm="6" md="4">
          <v-file-input
            color="#0F2027"
            outlined
            rounded
            dense
            :required="true"
            prepend-icon="mdi-attachment"
            label="Choose File For Import"
            show-size
            v-model="file"
            name="doc"
            @change="validateFile"
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pt-0 mt-0">
          <a
            href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/BulkSMS_CSVFormat.csv"
          >
            <v-btn
              color="blue-grey"
              outlined
              class="ma-2 white--text downbtn button"
            >
              Download CSV format
              <v-icon right dark>mdi-cloud-download</v-icon>
            </v-btn>
          </a>
        </v-col>
      </v-row>
      <!-- file atachment code end -->

      <v-row dense justify="center">
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            color="#0F2027"
            clearable
            dense
            v-model="principalno"
            label=" Principal Contanct No."
            placeholder="Enter Principal Contanct No."
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            color="#0F2027"
            clearable
            dense
            v-model="coordinatorno"
            label="Coordinator Contanct No."
            placeholder="Enter Coordinator Contanct No."
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            color="#0F2027"
            clearable
            dense
            v-model="teacherno"
            label="Teacher Contanct No."
            placeholder="Enter Teacher Contanct No."
            outlined
          ></v-text-field>
        </v-col>

        <p style="font-style: italic">*Above personnel will also receive SMS</p>
      </v-row>

      <v-row class="justify-center">
        <v-btn
          class="button"
          :disabled="disabled"
          :loading="fetch_loader"
          @click="sendsms(jsonparams)"
          >Send SMS <v-icon>mdi-cellphone-message</v-icon></v-btn
        >
      </v-row>
      <!-- 
      <v-row dense v-if="failed_sms_student_list.length > 0">
        {{ failed_sms_student_list }}
      </v-row> -->
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="failsmsdailog" width="700px">
      <v-card>
        <v-card-title>
          <span>Following students have not received SMS</span>
        </v-card-title>
        <!-- excel btn code -->
        <v-row dense>
          <v-col cols="12" sm="1" md="1"></v-col>
          <v-col cols="12" sm="6" md="6">
            <!-- <v-btn rounded color="success" outlined @click="ExportToExcel()"
              ><v-icon color="success">mdi-export</v-icon>Export</v-btn
            > -->
            <v-btn
              rounded
              color="success"
              outlined
              @click="fnExcelReport('my-table-id', 'WhatsAppFailedReport')"
              :loading="loader"
              ><v-icon color="success">mdi-export</v-icon>Export</v-btn
            >
          </v-col>
        </v-row>
        <!-- excel code end -->
        <v-card-text>
          <div id="my-table-id">
            <v-simple-table height="300px" class="mytable">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Contact No.</th>
                    <th class="text-left">Error Message</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in failed_sms_student_list" :key="i">
                    <td>{{ item.number }}</td>
                    <td>{{ item.message }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>
        <v-row class="justify-center">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="failsmsdailog = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data() {
    return {
      loader:false,
      overlay: true,
      template: null,
      sms_template_array: [],
      preapproved_sms: "",
      teacherno: null,
      coordinatorno: null,
      principalno: null,
      template_details: "",
      snackbar_msg: "",
      snackbar: "",
      color: "",
      jsonparams: [],
      fetch_loader: false,
      json_value: "",
      file: null,
      disabled: true,
      failed_sms_student_list: [],
      failsmsdailog: false,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
      showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onLoad() {
      this.overlay = true;
      this.fetch_loader = true;
      axios
        .post("/communication/sendWhatsappwithCSVData")
        .then((res) => {
          this.principalno = res.data.contact_1;
          this.coordinatorno = res.data.contact_2;
          this.teacherno = res.data.contact_3;

          this.sms_template_array = res.data.arrayList;
          this.overlay = false;
          this.fetch_loader = false;
        })
        .catch((error) => {
          this.overlay = false;
          this.fetch_loader = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.fetch_loader = false;
          this.overlay = false;
        });
    },

    get_template(template) {
      // this.preapproved_sms = template.template_name;
      this.preapproved_sms = template.template_data;

      const data = {
        tempid: this.template.id,
      };

      axios
        .post("communication/getWhatsappTemplateDetails", data)
        .then((res) => {
          this.template_details = res.data;
          this.jsonparams = res.data.jsonparams;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        });
    },
    validateFile() {
      let file_name = this.file.name;
      let ext = file_name.split(".").pop();
      if (ext != "csv") {
        this.showSnackbar("#b71c1c", "Please upload only CSV file!");
        return;
      } else {
        this.disabled = false;
      }
    },
    sendsms(jsonparams) {
      this.overlay = true;

      console.log("in send sms");
      // console.log("inside sendsms ");
      if (this.file == null) {
        this.overlay = false;
        this.showSnackbar("#b71c1c", "Please upload a file!");
        return;
      }
      if (this.coordinatorno != null) {
        if (this.coordinatorno.length != 10) {
          this.overlay = false;
          this.showSnackbar(
            "#b71c1c",
            "Coordinator's Contact No. is not valid!"
          );
          return;
        }
      }
      if (this.principalno != null) {
        if (this.principalno.length != 10) {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Principal's Contact No. is not valid!");
          return;
        }
      }
      if (this.teacherno != null) {
        if (this.teacherno.length != 10) {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Teacher's Contact No. is not valid!");
          return;
        }
      }
      if (this.template == null) {
        this.showSnackbar("#b71c1c", "Please select Template!");
        return;
      }

      let formData = new FormData();
      for (var i = 0; i < this.jsonparams.length; i++) {
        formData.append(this.jsonparams[i].name, this.jsonparams[i].value);
      }
      formData.append("file", this.file);
      formData.append("coordinator_no", this.coordinatorno);
      formData.append("principal_no", this.principalno);
      formData.append("teacher_no", this.teacherno);

      //   show formdata code
      formData.append("tempid", this.template.id);
      for (var pair of formData.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }
      //   show formdata code end

      //   api call sendsms
      axios
        .post("/communication/sendWhatsappMessage", formData)
        .then((res) => {
          this.overlay = false;
          console.log("res.data is--");
          console.log(res.data);
          if (res.data.wronglist.length > 0) {
            for (var i = 0; i < res.data.wronglist.length; i++) {
              this.failed_sms_student_list = res.data.wronglist;
            }
            this.failsmsdailog = true;

            this.showSnackbar("#b71c1c", "Incorrenct Contact No.");
            // show snackbar
          } else if (res.data.code == "SUCCESS") {
            this.showSnackbar(
              "success",
              "SMS has been sent successfully to selected students..."
            );
          } else {
            this.showSnackbar(
              "#b71c1c",
              "Something went wrong, please try again later!"
            );
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
  },
};
</script>

<style></style>
